"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVE_INTEGRATIONS_COUNT_SUBROUTE = exports.DashboardIntegrationType = void 0;
var DashboardIntegrationType;
(function (DashboardIntegrationType) {
    DashboardIntegrationType["GitHub"] = "GitHub";
    DashboardIntegrationType["JIRACloud"] = "Jira-Cloud";
    DashboardIntegrationType["JIRAServer"] = "Jira-Server";
    DashboardIntegrationType["Slack"] = "Slack";
})(DashboardIntegrationType = exports.DashboardIntegrationType || (exports.DashboardIntegrationType = {}));
exports.ACTIVE_INTEGRATIONS_COUNT_SUBROUTE = "activeCount";
//# sourceMappingURL=dashboard-integration.js.map